import styled from 'styled-components'

export const Page = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 32px 0 48px;
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
`

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const Title = styled.h5`
  margin: 0;
  font-size: 28px;
  font-weight: 700;
`

export const Subtitle = styled.p`
  margin: 0;
  color: #5f6b78;
  font-size: 14px;
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 20px;
  align-items: start;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
`

export const Card = styled.div`
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 2px 14px rgba(15, 23, 42, 0.08);
  padding: 20px;
  min-width: 0;
`

export const SectionTitle = styled.h6`
  margin: 0 0 16px;
  font-size: 18px;
  font-weight: 700;
`

export const MetaRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
`

export const MetaChip = styled.div`
  padding: 10px 14px;
  border-radius: 12px;
  background: #f4f7fa;
  color: #163247;
  font-size: 13px;
  font-weight: 600;
`

export const TableWrap = styled.div`
  overflow-x: auto;
  width: 100%;
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 900px;
`

export const Th = styled.th`
  text-align: left;
  padding: 12px 10px;
  border-bottom: 1px solid #e5e7eb;
  font-size: 13px;
  color: #475467;
  white-space: nowrap;
`

export const Td = styled.td`
  padding: 12px 10px;
  border-bottom: 1px solid #eef2f7;
  font-size: 14px;
  vertical-align: top;
`

export const RowButton = styled.button<{ $active?: boolean }>`
  width: 100%;
  border: 1px solid ${(props) => (props.$active ? '#2d749c' : '#e5e7eb')};
  background: ${(props) => (props.$active ? 'rgba(45, 116, 156, 0.08)' : '#ffffff')};
  color: #163247;
  border-radius: 12px;
  padding: 12px 14px;
  text-align: left;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    border-color: #2d749c;
    background: rgba(45, 116, 156, 0.06);
  }
`

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`

export const FullWidth = styled.div`
  grid-column: 1 / -1;
`

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 4px;
`

export const EmptyState = styled.div`
  padding: 24px;
  text-align: center;
  color: #667085;
  background: #f8fafc;
  border-radius: 12px;
`
